export const checkIfArrayIncludesObjectProperty = (arr, objectOwningProperty, propertyName) =>
    !arr ||
    (objectOwningProperty[propertyName] !== undefined &&
        Array.isArray(arr) &&
        !arr.some(element => objectOwningProperty[propertyName] === element))

export const flatten = (array, options = {}) => {
    const config = {
        excludeParents: false,
        childrenProperty: 'children',
        ...options
    }
    
    const result = []
    if (!array) return result

    const traverse = item => {
        const hasChildren = item[config.childrenProperty] && Array.isArray(item[config.childrenProperty]) && item[config.childrenProperty].length > 0
        const shouldInclude = !config.excludeParents || !hasChildren
        
        if (shouldInclude) result.push({...item, children: undefined})
        if (hasChildren) item[config.childrenProperty].forEach(traverse)
    }

    array.forEach(traverse)
    return result
}